export interface ICancelablePromise<T> extends Promise<T> {
	cancel: () => void;
}

export class PromiseHelper {
	public static cancelable<T>(value: T | PromiseLike<T>, cancel: () => void): ICancelablePromise<T> {
		let promise = Promise.resolve(value) as ICancelablePromise<T>;
		promise.cancel = cancel;
		return promise;
	}
}